export default __webpack_public_path__ + "static/media/umb-logo.54a70f4a.webp";